import { render, staticRenderFns } from "./lackHandleTypeDialog.vue?vue&type=template&id=23c042e0&scoped=true"
import script from "./lackHandleTypeDialog.vue?vue&type=script&lang=js"
export * from "./lackHandleTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./lackHandleTypeDialog.vue?vue&type=style&index=0&id=23c042e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c042e0",
  null
  
)

export default component.exports